module.exports = __webpack_public_path__ + "media/images/favicon-36792f664b24b41b624e978fc84434f5.ico";